<template>
  <div class="contact-us full-screen">
    <div class="wrapper section content">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-md-offset-2 text-center">
            <h2 class="title text-danger">404</h2>
            <h2 class="title"><a href="/admin">Sayfa bulunamadı. Anasayfaya dönmek için lütfen tıklayınız.</a></h2>
          </div>
        </div>
      </div>
    </div>
    <footer class="footer">
      <div class="container-fluid">
        <nav>
          <ul class="footer-menu">
            <li>
              <router-link :to="{ path: '/admin' }">Panel</router-link>
            </li>
          </ul>
        </nav>
        <div class="copyright text-center">
          &copy; Coded with
          <i class="fa fa-heart heart"></i> by
          <a href="#" target="_blank">{{ process.env.VUE_APP_COMPANY_NAME }}</a>.
          Designed by <a href="#" target="_blank">kadir</a>.
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {}

</script>
